// ── OnboardingClaudePanel (Evo Brain — inducción, 2026-08-05) ────────────────
// Ya no renderiza UI propia — ver contexts/AssistantContext.tsx +
// components/assistant/AssistantDock.tsx. Conserva el único comportamiento
// propio: el saludo de bienvenida.
//
// El saludo se dispara UNA vez por conversación, no una por sesión de browser
// (2026-08-31). El mecanismo viejo era sessionStorage, y como el saludo se
// persiste en la conversación igual que cualquier mensaje, cada pestaña nueva
// agregaba otro "Hola, soy nuevo acá." al mismo hilo: Eduardo terminó con ocho
// saludos idénticos apilados, cada uno contestado igual. La condición correcta
// no es "¿ya saludé en esta pestaña?" sino "¿esta conversación ya empezó?".

import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useAssistantModule, useRegisterAssistantActive } from '../../contexts/AssistantContext.js';

const AUTO_WELCOME_PROMPT = 'Hola, soy nuevo acá.';

export function OnboardingClaudePanel() {
  const { t } = useTranslation();

  const assistant = useAssistantModule('onboarding', null, undefined);
  useRegisterAssistantActive('onboarding', null, {
    title: t('onboarding.assistant.title'),
    placeholder: t('onboarding.assistant.placeholder'),
    emptyHint: t('onboarding.assistant.empty'),
  });

  const autoFiredRef = useRef(false);
  const { loaded, messages, hasOlderMessages, streaming, sendMessage } = assistant;

  useEffect(() => {
    if (autoFiredRef.current) return;
    // Esperar a saber qué hay: sin esto, "todavía no cargó" se lee como
    // "conversación vacía" y el saludo se duplica.
    if (!loaded) return;
    if (streaming.phase !== 'idle') return;
    // Ya se habló acá — hoy o cualquier otro día. El panel se limpia a diario
    // (ver getConversationMessages), así que mirar solo lo de hoy volvería a
    // saludar cada mañana a alguien que ya hizo la inducción.
    if (messages.length > 0 || hasOlderMessages) { autoFiredRef.current = true; return; }

    autoFiredRef.current = true;
    void sendMessage(AUTO_WELCOME_PROMPT);
  }, [loaded, messages.length, hasOlderMessages, streaming.phase, sendMessage]);

  return null;
}
